import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import useInput from "../Assets/UseInput";
import { useTranslation} from "react-i18next";
import {Col, Alert, Form, FormGroup, Input, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
var serialize = require('serialize-javascript');

function Family (props) {
    // fetch data from local Storage
        let history = useNavigate();
    const [d, setDead] = useState()
    const [Age, setAge]= useState("")
    const [isLoading, setIsLoading] = useState(false);

    const next = () =>{

        let nextLocation = {}
        if (Field17HasPartner === "yes"){
            nextLocation = {
                pathname: '../family-partner',
                state: { d: d }
            }
        }else if (Field18HasChildren === "yes"){
            nextLocation = {
                pathname: '../family-children',
                state: { d: d }
            }
        }else if (Field19HasParents === "yes"){
            nextLocation = {
                pathname: '../family-parents',
                state: { d: d }
            }
        }else if (Field20HasPersons === "yes"){
            nextLocation = {
                pathname: '../family-other',
                state: { d: d }
            }
        }else if (Age > 15){
            nextLocation = {
                pathname: '../job',
                state: { d: d }
            }

        }else {
            nextLocation = {
                pathname: '../circumstances',
                state: { d: d }
            }
        }
        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const prevLocation = {
        pathname: '../personal-details',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }

// set control value and name to classic inputs using the custom Hook useInput
    const {value: Field2101Link, bind: bindField2101Link, reset: setField2101Link } = useInput('');

// radio input custom handleChange
    const [Field17HasPartner, setField17HasPartner] = useState((""));
    const handleChangeField17HasPartner = (e) => {
        let value = e.target.value
        setField17HasPartner(value);
    }
    const [Field18HasChildren, setField18HasChildren] = useState((""));
    const handleChangeField18HasChildren = (e) => {
        let value = e.target.value
        setField18HasChildren(value);
    }
    const [Field19HasParents, setField19HasParents] = useState((""));
    const handleChangeField19HasParents = (e) => {
        let value = e.target.value
        setField19HasParents(value);
    }
    const [Field20HasPersons, setField20HasPersons] = useState((""));
    const handleChangeField20HasPersons = (e) => {
        let value = e.target.value
        setField20HasPersons(value);
    }
    const [Field21HasLink, setField21HasLink] = useState((""));
    const handleChangeField21HasLink = (e) => {
        let value = e.target.value
        setField21HasLink(value);
    }

    const [stored, setStored] =  useState("")

    useEffect(() => {
                    window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const storedAge = localStorage.getItem('Age')
            setAge(storedAge)

            const dead = localStorage.getItem('isDead')
           //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            //setDead(false)
            setIsLoading(false);

            const family = JSON.parse(localStorage.getItem('family'))

            if (family){
                setStored(true)
                !!family.Field17HasPartner && setField17HasPartner(family.Field17HasPartner)
                !!family.Field18HasChildren && setField18HasChildren(family.Field18HasChildren)
                !!family.Field19HasParents && setField19HasParents(family.Field19HasParents)
                !!family.Field20HasPersons && setField20HasPersons(family.Field20HasPersons)
                !!family.Field21HasLink && setField21HasLink(family.Field21HasLink)
                !!family.Field2101Link && setField2101Link(family.Field2101Link)

                if (localStorage.getItem('Age') < 16){
                    setField17HasPartner('no')
                    setField18HasChildren('no')
                    localStorage.removeItem('children')
                    localStorage.removeItem('familyPartner')
                    localStorage.removeItem('jobPartner')
                    localStorage.removeItem('job')
                    localStorage.removeItem('jobEmployee')
                    localStorage.removeItem('jobStudent')
                    localStorage.removeItem('jobIndependant')
                    localStorage.removeItem('jobPartnerStudent')
                    localStorage.removeItem('jobPartnerIndependant')
                    localStorage.removeItem('jobPartnerEmployee')

                }
            }

        };
        fetchData()
    }, []);



// Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {
                    window.scrollTo(0, 0)
        evt.preventDefault();
        let notValid = (Age > 15 && Field17HasPartner === '') || (Age > 15 && Field18HasChildren === '') || Field19HasParents === '' || Field20HasPersons === '' || Field21HasLink === '' || (Field21HasLink === 'yes' && Field2101Link === '')
            setNotValid(notValid)

        if (!notValid){
            let family = {
                Field17HasPartner : Field17HasPartner,
                Field18HasChildren : Field18HasChildren,
                Field19HasParents : Field19HasParents,
                Field20HasPersons : Field20HasPersons,
                Field21HasLink : Field21HasLink,
                Field2101Link : Field2101Link
            }
            //let stringInfo = JSON.stringify(family)
            let stringInfo = serialize(family, {isJSON: true});
            localStorage.setItem("family" , stringInfo)
           //console.log(JSON.parse(stringInfo))
            next()
        }

    }



    const { i18n } = useTranslation();
    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
<BreadCrumb n={3}/>
                    <Row>
                        <Col>

                            <h3>{ d? i18n.t("FAMILYTITLEDEATH"): i18n.t("FAMILYTITLE") }</h3>
                            <h4 className={"text-primary"}>{  d? i18n.t("COMPOFAMILYTITLEDEATH"): i18n.t("COMPOFAMILYTITLE") }</h4>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">
                                    {(Age >= 15) &&
                                    <div>
                                        <FormGroup className={(NotValid && Field17HasPartner === "") ? "text-danger" : "text"} check>
                                            <Label for="Field17HasPartner">{d? i18n.t("field17HasPartnerDEATH") : i18n.t("field17HasPartner")} <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field17HasPartner"  onChange={handleChangeField17HasPartner} value="no"
                                                           checked={(Field17HasPartner === "no") }/>
                                                    {i18n.t("NO")}
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field17HasPartner"  onChange={handleChangeField17HasPartner} value="yes"
                                                           checked={(Field17HasPartner === "yes") }/>
                                                    {i18n.t("YES")}
                                                </Label>
                                            </div>
                                            {(NotValid && Field17HasPartner === "") && <span className="help-block form-error">{i18n.t("Obligatoire")}</span>}
                                        </FormGroup>
                                        <FormGroup className={(NotValid && Field18HasChildren === "") ? "text-danger" : "text"} check>
                                            <Label for="Field18HasChildren">{d? i18n.t("field18HasChildrenDEATH") : i18n.t("field18HasChildren")} <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field18HasChildren"  onChange={handleChangeField18HasChildren} value="no" checked={(Field18HasChildren === "no") }/>
                                                    {i18n.t("NO")}
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field18HasChildren"  onChange={handleChangeField18HasChildren} value="yes" checked={(Field18HasChildren === "yes") }/>
                                                    {i18n.t("YES")}
                                                </Label>
                                            </div>

                                            {(NotValid && Field18HasChildren === "") &&
                                            <span className="help-block form-error">{i18n.t("Obligatoire")}</span>}
                                        </FormGroup>
                                    </div>
                                    }
                                    <FormGroup className={(NotValid && Field19HasParents === "") ? "text-danger" : "text"} check>
                                        <Label for="Field19HasParents">{ d? i18n.t("field19HasParentsDEATH") : i18n.t("field19HasParents")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field19HasParents"  onChange={handleChangeField19HasParents} value="no" checked={(Field19HasParents === "no")}/>
                                                { i18n.t("NO")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field19HasParents"  onChange={handleChangeField19HasParents} value="yes" checked={(Field19HasParents === "yes")}/>
                                                { i18n.t("YES")}
                                            </Label>
                                        </div>

                                        { (NotValid && Field19HasParents === "") &&<span className="help-block form-error">{ i18n.t("Obligatoire")}</span>}
                                    </FormGroup>
                                    <FormGroup className={(NotValid && Field20HasPersons === "") ? "text-danger" : "text"} check>
                                        <Label for="Field20HasPersons">{ d? i18n.t("field20HasPersonsDEATH") : i18n.t("field20HasPersons")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field20HasPersons"  onChange={handleChangeField20HasPersons} value="no" checked={(Field20HasPersons === "no")}/>
                                                { i18n.t("NO")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field20HasPersons"  onChange={handleChangeField20HasPersons} value="yes" checked={(Field20HasPersons === "yes")}/>
                                                { i18n.t("YES")}
                                            </Label>
                                        </div>

                                        {(NotValid && Field20HasPersons === "")&& <span className="help-block form-error">{ i18n.t("Obligatoire")}</span>}
                                    </FormGroup>
                                    <FormGroup className={(NotValid && Field21HasLink === "") ? "text-danger" : "text"} check>
                                        <Label for="Field21HasLink">{ d? i18n.t("field21HasLinkDEATH") : i18n.t("field21HasLink")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field21HasLink" onChange={handleChangeField21HasLink}   value="no" checked={(Field21HasLink === "no")}/>
                                                { i18n.t("NO")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field21HasLink" onChange={handleChangeField21HasLink} value="yes" checked={(Field21HasLink === "yes")}/>
                                                { i18n.t("YES")}
                                            </Label>
                                        </div>
                                        {(Field21HasLink === "yes") &&
                                        <div>
                                            <div className="formlevel02">
                                                <div className={(NotValid && Field2101Link === "")? "form-group require text-danger": ""}>
                                                    <Label for="Field2101Link">{ i18n.t("field2101Link")} <span className={"text-danger"}>*</span></Label>
                                                    <Input type={"textarea"} className="form-control" rows="3" {...bindField2101Link} placeholder={ d? i18n.t("placeholderfield2101LinkDeath") : i18n.t("placeholderfield2101Link")}/>
                                                    { (NotValid && Field2101Link === "") && <span className="help-block form-error">{ i18n.t("Obligatoire")}</span>}
                                                </div>
                                            </div>
                                        </div>}
                                    </FormGroup>

                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                </div>
                            </Form>


                            <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default Family

